






import Vue from 'vue'
import Component from 'vue-class-component'
import Status from './Status.vue'
import { EStatementStatuses } from '@zunta/configurations'
import { EStatusType } from '@/components/statuses/EStatusType'
import { DO_NOT_BILL_STATUSES, STATEMENT_STATUSES_LABEL_MAP } from '@/constants'

@Component({
  components: { Status },
  props: {
    status: {
      status: String,
      required: true
    }
  }
})
export default class StatusStatement extends Vue {
  get type (): EStatusType {
    if (!this.$props.status) {
      return EStatusType.default
    }

    const success: any[] = [EStatementStatuses.READY_TO_MAIL, EStatementStatuses.READY_TO_EMAIL, EStatementStatuses.READY_TO_PRINT, EStatementStatuses.DELIVERED, EStatementStatuses.EMAILED]
    const process: any[] = [EStatementStatuses.IN_TRANSIT, EStatementStatuses.PRINTED_LOCALLY, EStatementStatuses.PENDING]
    const pending: any[] = [...DO_NOT_BILL_STATUSES, EStatementStatuses.IN_PROCESS, EStatementStatuses.ALREADY_SENT]
    const attention: any[] = [EStatementStatuses.NEEDS_FIX, EStatementStatuses.REROUTED]
    const error: any[] = [EStatementStatuses.NEEDS_REVIEW, EStatementStatuses.RETURNED, EStatementStatuses.EMAIL_RETURNED]

    if (success.includes(this.$props.status)) {
      return EStatusType.success
    } else if (process.includes(this.$props.status)) {
      return EStatusType.process
    } else if (pending.includes(this.$props.status)) {
      return EStatusType.pending
    } else if (attention.includes(this.$props.status)) {
      return EStatusType.attention
    } else if (error.includes(this.$props.status)) {
      return EStatusType.error
    }

    return EStatusType.default
  }

  get text (): string {
    if (!this.$props.status) {
      return ''
    }
    return STATEMENT_STATUSES_LABEL_MAP[this.$props.status]
  }
}
